<template>
    <div class="mb-4">
        <template v-for="(item, idx) of items" :key="idx">
            <CategoryItem :item="item"></CategoryItem>
        </template>
    </div>
</template>
<script>
// import SearchPromotionCategoryItem from "./SearchPromotionCategoryItem.vue";
import CategoryItem from "../component/CategoryItem.vue";
//helper
import Locale from "@/helper/locale/Locale.js";
//service
import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";

// mixins
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

// config
import ConfigManager from "@/config/ConfigManager";

export default {
    name: 'SearchPromotionSubCatogaryList',
    props: {
        modalController: { type: Object }
    },
    components: {
        CategoryItem
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    emits: ["onLoaded", "onError"],
    data: function () {
        return {
            dashboardConfig: ConfigManager.getDashboardConfig(),
            items: []
        }
    },
    computed: {},
    mounted: function () {
        this.getCategory()
    },
    methods: {
        getCategory: function () {
            var dashboardConfig = ConfigManager.getDashboardSearchPromotionSubCategoryConfig();
            var configBuilder = new SubDashboardConfigBuilder();
            configBuilder.setLocale(Locale.getLocaleCode());

            var params = configBuilder.create().getParams();

            // params.push({
            //     cat: this.$route.params.cat
            // });

            BzbsDashboard.apiGetSubDashboard(params, dashboardConfig).subscribe((data) => {
                this.items = data;

                console.log(this.items)
                // this.modalController.loadingModal.hide()
                this.$emit("onLoaded")
            }, (err) => {
                // this.modalController.loadingModal.hide()
                this.errorApi(err)
                // console.log(err);
            });
        },
    }
}
</script>
